<markdown [data]="htmlString" class="html-text"></markdown>
